import { useDispatch, useSelector } from "react-redux";
import {
  selectSelectedTake,
  updateSelectedTake,
} from "../../app/slices/TrainingSlice";
import PiInputfield from "../../components/PiInputField";
import MovieCreationOutlinedIcon from "@mui/icons-material/MovieCreationOutlined";
import Take from "../../models/Take";
import { useTranslation } from "react-i18next";
import PiSwitch from "../../components/PiSwitch";
import Take360 from "../../models/Take360";
import PiSelectAssetButton from "../../components/PiSelectAssetButton";
import { AssetKey } from "../../dto/AssetDTO";
import { useEffect, useState } from "react";
import EditorColumn, {
  EditorColumnFieldGroup,
  EditorColumnHeader,
  EditorColumnSection,
} from "../editor_columns/EditorColumn";

export default function Take360PropertiesColumn() {
  const take = useSelector(selectSelectedTake);
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const [takeNameValue, setTakeNameValue] = useState(take?.name ?? "");

  useEffect(() => {
    setTakeNameValue(take?.name ?? "");
  }, [take, take?.name]);

  const onChangeTakeName = (newName: string) => {
    dispatch(updateSelectedTake({ ...take, name: newName } as Take));
  };

  const onChangeField = (field: keyof Take360, value: any) => {
    dispatch(updateSelectedTake({ ...take, [field]: value } as Take360));
  };

  const takeName = (
    <PiInputfield
      label={t("bubble_name")}
      value={takeNameValue}
      placeholder={t("bubble_name")}
      onChange={onChangeTakeName}
      square
    />
  );

  const automaticTransition = (
    <PiSwitch
      checked={take?.automaticTransition ?? false}
      label={t("edit_bubble_dialog.automatic_transition")}
      onChange={(checked) => onChangeField("automaticTransition", checked)}
    />
  );

  const is360Image = (
    <PiSwitch
      checked={take?.is360Image ?? false}
      label={t("edit_bubble_dialog.360_image")}
      onChange={(checked) => onChangeField("is360Image", checked)}
    />
  );

  const changeBubble = (
    <PiSelectAssetButton
      label={t("edit_bubble_dialog.bubble")}
      text={t("change_bubble")}
      assetType={AssetKey.Image}
      square
      onAssetSelectCallback={(asset) => onChangeField("assetId", asset.assetId)}
    />
  );

  return (
    <EditorColumn
      testId="take360-properties-column"
      widthClassName="w-full min-w-0"
      borderSide="left"
      header={
        <EditorColumnHeader
          icon={<MovieCreationOutlinedIcon fontSize="inherit" />}
          title={take?.name ?? t("edit_bubble_dialog.bubble")}
          testId="take360-properties-header"
        />
      }
    >
      <EditorColumnSection
        title={t("edit_bubble_dialog.bubble")}
        icon={<MovieCreationOutlinedIcon fontSize="inherit" />}
        defaultExpanded
        testId="take360-properties-take-section"
      >
        <EditorColumnFieldGroup>
          {takeName}
          {changeBubble}
          {automaticTransition}
          {is360Image}
        </EditorColumnFieldGroup>
      </EditorColumnSection>
    </EditorColumn>
  );
}
